<template>
  <div class="single-pic-or-pdf-card">
    <div class="img-wrapper">
      <template v-if="imgUrl">
        <img
          v-if="!imgLoadErr"
          :src="imgUrl"
          class="w-full h-full object-contain rounded"
          @error.once="handleImageError"
        >
        <img v-else :src="DefaultImg" class="w-[42px] h-[42px]">
      </template>
      <img v-else src="@/assets/pdf_icon.png" class="w-[42px] h-[42px]">
      <!-- hover时的图标 -->
      <div class="preview-icon" @click="handlePreview">
        <SvgIconfont symbol-name="icon_a-eye_lineyanjing" class="icon-eye text-white text-base" />
      </div>
      <div v-if="showDel" class="absolute top-[-6px] right-[-6px] z-20 leading-none" @click="handleDel">
        <SvgIconfont symbol-name="icon_a-close_circle_fillguanbi" class="text-cr06 text-base bg-white rounded-lg" />
      </div>
    </div>
  </div>
</template>

<script>
import DefaultImg from '@/assets/default_img.png';

export default {
  name: 'SinglePicOrPdfCard',
  props: {
    fileUrl: {
      type: String,
      default: ''
    },
    imgId: {
      type: String,
      default: ''
    },
    showDel: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imgUrl: '',
      pdfUrl: '',
      imgLoadErr: false,
      DefaultImg,
    };
  },
  computed: {
    isPdf() {
      return Boolean(this.pdfUrl);
    },
    isImageNoSuffix() {
      if (!this.imgUrl) return false;
      const isLocal = this.imgUrl.startsWith('blob:');
      if (isLocal) return false;
      const hasSuffix = /\w(\.gif|\.jpeg|\.png|\.jpg|\.bmp|\.tif)/i.test(this.imgUrl);
      return !hasSuffix;
    }
  },
  created() {
    if (this.fileUrl.toLowerCase().includes('.pdf')) {
      this.pdfUrl = this.fileUrl;
    } else {
      this.imgUrl = this.fileUrl;
    }
  },
  methods: {
    handlePreview() {
      if (this.imgUrl) {
        if (this.isImageNoSuffix) {
          window.open(this.imgUrl, '_blank', 'noreferrer=yes');
          return;
        }
        if (this.imgLoadErr) return;
        const viewUrl = this.imgUrl;
        this.$viewerApi({
          images: [viewUrl],
          options: {
            toolbar: {
              zoomIn: true,
              zoomOut: true,
              oneToOne: true,
              reset: true,
              rotateLeft: true,
              rotateRight: true,
              flipHorizontal: true,
              flipVertical: true
            }
          }
        });
        return;
      }
      const url = this.isPdf ? this.pdfUrl : this.imgUrl;
      window.open(url);
    },
    handleImageError(e) {
      e.target.src = DefaultImg;
      this.imgLoadErr = true;
    },
    handleDel() {
      this.$emit('del', this.imgId);
    },
  }
};
</script>

<style lang="less" scoped>
.single-pic-or-pdf-card {
  width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .img-wrapper {
    position: relative;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f2f2f2;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      .preview-icon {
        background: rgba(0, 0, 0, 0.5);
        .icon-eye {
          visibility: visible;
        }
      }
    }
    .preview-icon {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      .icon-eye {
        visibility: hidden;
      }
    }
  }
}
</style>
